// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".y-margin[data-v-15373f5b]{margin:100px 0 50px}@media (min-width:1024px){.y-margin[data-v-15373f5b]{margin:100px 0}}.background-style[data-v-15373f5b]{--tw-bg-opacity:1;background-color:#f6f6f6}@supports (color:rgb(0 0 0/0)){.background-style[data-v-15373f5b]{background-color:rgb(246 246 246/var(--tw-bg-opacity))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
